export const formatOptionName = optionName => optionName.replace(/ *\[[^\]]*]\s/, '')

export default formatOptionName